import e from "../managers/braze-instance.js";
import ea from "./push-manager-factory.js";
export function requestPushPermission(r, n) {
  if (e.rr())
    return ea.aa().subscribe((n, o, t) => {
      e.mr().requestImmediateDataFlush(), "function" == typeof r && r(n, o, t);
    }, n);
}
